import { getRegionLocal } from '../base';

const Statistics = Mach.requireModule('Statistics');

// PV
const lxPageView = (cid: string, lab?: object) => {
  try {
    if (!cid) {
      return;
    }
    const { region, locale, cityId } = getRegionLocal();
    Statistics?.pv(cid, {
      ...lab, region, locale, cityId, appName: Mach.env.appName, techFramework: 'machPro'
    });
  } catch (error) {
    console.log('lxPageView-error', error);
  }
};

const lxViewReport = (cid: string, bid: string, lab?: object) => {
  try {
    if (!cid || !bid) {
      return;
    }
    const { region, locale, cityId } = getRegionLocal();
    Statistics?.view(cid, bid, {
      ...lab, region, locale, cityId, appName: Mach.env.appName, techFramework: 'machPro'
    });
  } catch (error) {
    console.log('lxViewReport-error', error);
  }
};

const lxClickReport = (cid: string, bid: string, lab?: object) => {
  try {
    if (!cid || !bid) {
      return;
    }
    const { region, locale, cityId } = getRegionLocal();
    Statistics?.click(cid, bid, {
      ...lab,
      region,
      locale,
      cityId,
      appName: Mach.env.appName,
      techFramework: 'machPro',
    });
  } catch (error) {
    console.log('lxClickReport-error', error);
  }
};

export { lxPageView, lxViewReport, lxClickReport };
